import React, { forwardRef, useImperativeHandle } from 'react';
import classNames from 'classnames';
import { Modal } from 'ncoded-component-library';
import {
  ModalProps,
  ModalRef,
} from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import useCallbackRef from 'hooks/useCallbackRef';
import { useTranslation } from 'react-i18next';
import { DataRoomRFICategory } from 'router/subrouters/DataRoom/models/DataRoomRfi';
import OrganizeRequestedFilesSelect from './components/OrganizeRequestedFilesSelect';

import './OrganizeRequestedFilesModal.styles.scss';

type OrganizeRequestedFilesModalProps = {
  className?: string;
  dataRoomRfiId: string;
  dataRoomRFICategories: DataRoomRFICategory[];
} & ModalProps;

const OrganizeRequestedFilesModal: React.ForwardRefRenderFunction<
  ModalRef,
  OrganizeRequestedFilesModalProps
> = (props, ref) => {
  const { className, dataRoomRfiId, dataRoomRFICategories, ...rest } = props;

  const [modal, modalRef] = useCallbackRef<ModalRef>();

  useImperativeHandle(ref, () => modal, [modal]);

  const classes = classNames('organize-requested-files-modal', className);

  const { t } = useTranslation();

  return (
    <Modal
      ref={modalRef}
      className={classes}
      fullContent
      title={t('organiseRequestedFiles')}
      {...rest}
    >
      <p className="organize-requested-files-modal__description">
        {t('chooseDestinationForEachRequestedFile')}
      </p>

      {modal?.openState && (
        <OrganizeRequestedFilesSelect
          dataRoomRfiId={dataRoomRfiId}
          dataRoomRFICategories={dataRoomRFICategories}
          onClose={modal?.close}
        />
      )}
    </Modal>
  );
};

export default forwardRef(OrganizeRequestedFilesModal);
